import { render, staticRenderFns } from "./MahkemeSecim.vue?vue&type=template&id=f00583e4"
import script from "./MahkemeSecim.vue?vue&type=script&lang=ts"
export * from "./MahkemeSecim.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports